import * as React from 'react';

import { Button, Restore, Trash } from './style';

interface TrashButtonProps {
  isRemoved: boolean;
  disabled?: boolean;
  onClick: () => void;
}

const TrashButton: React.FC<TrashButtonProps> = React.memo(
  ({ isRemoved, disabled, onClick }) => {
    return (
      <Button onClick={onClick} disabled={!!disabled}>
        {isRemoved ? (
          <Restore data-testid="restore-icon" />
        ) : (
          <Trash data-testid="trash-icon" />
        )}
      </Button>
    );
  },
);

export default TrashButton;
